import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import CardDealerService from '@adv-mt/mt-card-dealer-service'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS = `mt-CardDealerLocations`

function CardDealerLocationsModalContent({services, pageName}) {
  const {i18n} = useContext(Context)

  return (
    <>
      <TitleBasic
        as={titleBasicTags.h2}
        preTitle={i18n.t('DEALER_LOCATIONS.DEALER_LOCATIONS_TITLE')}
        title={i18n.t('DEALER_LOCATIONS.DEALER_LOCATIONS_PRETITLE')}
        size={titleBasicSizes.s}
      />
      <div className={`${BASE_CLASS}-modalContent`}>
        {services.map(service => (
          <div className={`${BASE_CLASS}-modalService`} key={service.type}>
            <CardDealerService
              id={service.type}
              type="extended"
              service={service.title}
              description={service.description}
              isIncluded={service.isIncluded}
            />
          </div>
        ))}
      </div>
    </>
  )
}

CardDealerLocationsModalContent.displayName = 'CardDealerLocationsModalContent'
CardDealerLocationsModalContent.propTypes = {
  services: PropTypes.array.isRequired,
  pageName: PropTypes.string
}

export default React.memo(CardDealerLocationsModalContent)
